
 export default function getJsonCentroid(features){
  const fallbackCenter = [-60, -3]

  if (!features || features.length === 0) return fallbackCenter

  let totalX = 0, totalY = 0, totalPoints = 0

  for (const feature of features){
    const geometry = feature.geometry

    if (!geometry || !geometry.coordinates) continue

    const coordsArray = geometry.type === 'Polygon' ? [geometry.coordinates] : geometry.coordinates

    for (const polygon of coordsArray){
      for (const ring of polygon){
        for (const coord of ring){
          totalX += coord[0]
          totalY += coord[1]
          totalPoints++
        }
      }
    }
  }

  if (totalPoints === 0) return fallbackCenter

  return [totalX / totalPoints, totalY / totalPoints]
}